var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestSuiteCollection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "test_suite_collection_grey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11075512,0.291009585 L15.483188,3.99389184 C15.9206911,4.24811542 16.1019018,4.76167294 15.9434631,5.21353614 L15.9428219,11.1101134 C15.9428219,11.4733648 15.7469907,11.8098748 15.4271784,11.9961786 L9.055707,15.7078204 C8.38683262,16.097467 7.55251805,16.0973879 6.88372138,15.7076146 L0.515466892,11.9962083 C0.195754673,11.8098806 -2.57571742e-14,11.4734259 -2.57571742e-14,11.1102461 L-2.57571742e-14,4.90371154 L0.0552901344,4.93245532 C0.0449466137,4.73576299 0.0921259824,4.53403498 0.203288812,4.35215259 C0.293334434,4.20482176 0.419613132,4.08169203 0.570711859,3.99389184 L6.94314472,0.291009585 C7.61089088,-0.0970031949 8.44300897,-0.0970031949 9.11075512,0.291009585 Z M1.58819088,6.45149579 L1.58819088,10.817421 L7.19709255,14.0858181 L7.19676608,9.59579606 C7.11014126,9.55977602 7.02539601,9.51786878 6.94314472,9.47007435 L2.1689723,6.69558894 L1.58819088,6.45149579 Z M14.354761,6.45149579 L14.1665965,6.53147631 L9.11075512,9.47007435 C9.00604937,9.53091659 8.89730208,9.58221848 8.78578072,9.62398002 L8.78492,14.0610464 L14.354761,10.817421 L14.354761,6.45149579 Z M7.84251082,1.58056677 L7.75599862,1.62098477 L2.14629246,4.88018074 L7.75599862,8.14009916 C7.89511241,8.22093516 8.06276298,8.23440782 8.21138903,8.18051716 L8.29790122,8.14009916 L13.907615,4.8794509 L8.29790122,1.62098477 C8.15878744,1.54014878 7.99113687,1.52667611 7.84251082,1.58056677 Z",
    id: "Shape",
    fill: "#8C9BC0",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestSuiteCollection);
export default __webpack_public_path__ + "static/media/test-suite-collection.038b73ec67796e71172fc2a1b2259ec9.svg";
export { ForwardRef as ReactComponent };